import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

export { HeaderDesktop, HeaderMobile };
